import { render } from "./QuoteBreak.vue?vue&type=template&id=10491d77&scoped=true"
import script from "./QuoteBreak.vue?vue&type=script&lang=js"
export * from "./QuoteBreak.vue?vue&type=script&lang=js"

import "./QuoteBreak.vue?vue&type=style&index=0&id=10491d77&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10491d77"]])

export default __exports__